import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class AreaInsertService {

	private apiUrl = globalConst.baseAPI;
	constructor(private http: Http) { }

	insertArea(token, area: any) {
		console.log(area);

		return this.http
		.post(this.apiUrl + "area/v1/insertarea", area, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/area/service/area-insert/area-insert.service.ts